import { FeaturedAlbumBanner } from "@/components/ui/FeaturedAlbumBanner";
import { FeaturedAlbumsControllerListPlacement } from "@/lib/lutely-api/gen/dtos";
import { useFeaturedAlbumsControllerList } from "@/lib/lutely-api/gen/featured-albums/featured-albums";
import { FeaturedAlbumCarousel } from "./FeaturedAlbumCarousel";

type FeaturedAlbumsSectionProps = {
  variant?: "stacked" | "carousel";
};

export default function FeaturedAlbumsSection({
  variant = "carousel",
}: FeaturedAlbumsSectionProps) {
  const { data: featured } = useFeaturedAlbumsControllerList({
    placement: FeaturedAlbumsControllerListPlacement.MARKETPLACE,
  });

  const items = (featured ?? []).map((config) => ({
    album: config.album,
    isExclusive: config.isExclusive,
    creatorIdOverride: config.creatorIdOverride ?? undefined,
    stageNameOverride: config.stageNameOverride ?? undefined,
    labelOverride: config.labelOverride ?? undefined,
    bannerImageUrl: config.album.bannerUrl ?? undefined,
    imagePosition: config.imagePosition ?? undefined,
    animateImage: config.animateImage,
  }));

  if (items.length === 0) return null;

  if (variant === "stacked") {
    return (
      <div className="flex flex-col space-y-6 mb-8">
        {items.map((item, index) => (
          <FeaturedAlbumBanner
            key={`${item.album.albumId}-${index}`}
            album={item.album}
            isExclusive={item.isExclusive}
            stageNameOverride={item.stageNameOverride}
            labelOverride={item.labelOverride}
            bannerImageUrl={item.bannerImageUrl}
            imagePosition={item.imagePosition}
            animateImage={item.animateImage}
          />
        ))}
      </div>
    );
  }

  return <FeaturedAlbumCarousel items={items} className="mb-8" />;
}
